var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTorusIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#0364FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.116 21.361a3.115 3.115 0 00-3.115 3.116v3.629a3.115 3.115 0 003.115 3.115h5.512v20.302a3.115 3.115 0 003.116 3.116h3.629a3.115 3.115 0 003.115-3.116v-23.39-3.657a3.115 3.115 0 00-3.115-3.115H24.116z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.885 31.221a4.93 4.93 0 100-9.86 4.93 4.93 0 000 9.86z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorusIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzYiIGN5PSIzNiIgcj0iMzYiIGZpbGw9IiMwMzY0RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC4xMTY0IDIxLjM2MTNDMjIuMzk1OCAyMS4zNjEzIDIxLjAwMSAyMi43NTYxIDIxLjAwMSAyNC40NzY3VjI4LjEwNTlDMjEuMDAxIDI5LjgyNjUgMjIuMzk1OCAzMS4yMjEzIDI0LjExNjQgMzEuMjIxM0gyOS42Mjg0VjUxLjUyMzRDMjkuNjI4NCA1My4yNDQgMzEuMDIzMiA1NC42Mzg4IDMyLjc0MzggNTQuNjM4OEgzNi4zNzNDMzguMDkzNSA1NC42Mzg4IDM5LjQ4ODQgNTMuMjQ0IDM5LjQ4ODQgNTEuNTIzNFYyOC4xMzIzQzM5LjQ4ODQgMjguMTIzNSAzOS40ODg1IDI4LjExNDcgMzkuNDg4NSAyOC4xMDU5VjI0LjQ3NjdDMzkuNDg4NSAyMi43NTYxIDM4LjA5MzcgMjEuMzYxMyAzNi4zNzMxIDIxLjM2MTNIMzIuNzQzOEgyNC4xMTY0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTQ2Ljg4NTEgMzEuMjIxM0M0OS42MDc4IDMxLjIyMTMgNTEuODE1MSAyOS4wMTQxIDUxLjgxNTEgMjYuMjkxM0M1MS44MTUxIDIzLjU2ODYgNDkuNjA3OCAyMS4zNjEzIDQ2Ljg4NTEgMjEuMzYxM0M0NC4xNjIzIDIxLjM2MTMgNDEuOTU1MSAyMy41Njg2IDQxLjk1NTEgMjYuMjkxM0M0MS45NTUxIDI5LjAxNDEgNDQuMTYyMyAzMS4yMjEzIDQ2Ljg4NTEgMzEuMjIxM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };